import deepGroupBy from "@/services/groupByUtil.js";
import VestingMixin from "@/mixins/VestingMixin.js";
import BaseModelIssuance from "@/models/BaseModelIssuance.js"
import BaseModelTransfer from "@/models/BaseModelTransfer.js"
import BaseModelVesting from "@/models/BaseModelVesting.js"

import moment, { locale } from "moment";
import { isNullOrUndefined } from "util";
import _ from 'lodash'

export default {
    name: "FMVMixin",
    mixins: [VestingMixin],
    data: function () {
        return {
            isNonPartner: false,
            InvestmentValuationAPIData : [],
            newInvestment : [],
            isNew : false,
            ExceptionProgram : {
                "Master" : {"Id" : 81,"ProgramID" : 30010, "InvestmentId" : 49,"InvestmentInvestmentId" : 500010},
               "Child" : {"Id" : 82,"ProgramID" : 30011, "InvestmentId" : 50,"InvestmentInvestmentId" : 500011}
            },
            ExceptionTransferPartnerId : [1984,1607,1591,1602,1515,
                1569,
                1630,
                1550]
            
        };
    },
    methods: {
        getProgramandUnit: function () {
            const self = this;
            let tempProgramUnit = []

            let transactionLogAPIData = self.withFilter(
                self.BaseModelTransactionLog.list
            );

            let filteredTransactionLog = _.filter(transactionLogAPIData, function (
                obj
            ) {
                return (
                    obj.PartnerId == self.criteriaData.Partner.Id &&
                    new Date(obj.TransactionDate) < new Date(self.taxDateToFilter)
                );
            });

            //Merge Exception Programs
            if(filteredTransactionLog.length) {
                filteredTransactionLog.forEach( function(item) {
                    if(item.ProgramId == self.ExceptionProgram.Child.Id){
                        item.ProgramId = self.ExceptionProgram.Master.Id;
                    }                    
                });
            }

            if (filteredTransactionLog.length) {
                var localGridJson = window.linq.from(filteredTransactionLog)
                    .groupBy("$.PartnerId", null, function (key, obj) {
                        return {
                            PartnerId: key,
                            ProgramResult: window.linq.from(obj)
                                .groupBy(
                                    "$.ProgramId",
                                    null,
                                    //"{ PartnerId: $$.min('($.PartnerId)'),ProgramId: $, Unit: $$.sum('Number($.Unit)')}"
                                    function (key1, obj1) { //note
                                        return {
                                            ProgramId: key1,
                                            UnitTypeResult: window.linq.from(obj1)
                                                .groupBy(
                                                    "$.UnitType",
                                                    null,
                                                    "{ PartnerId: $$.min('($.PartnerId)'), ProgramId: $$.min('($.ProgramId)'), UnitType: $, Unit: $$.sum('Number($.Unit)')}"
                                                )
                                                .toArray()
                                        };
                                    }
                                )
                                .toArray()
                        };
                    })
                    .toArray();

                if (localGridJson.length) {
                    if (localGridJson[0].ProgramResult.length) {
                        // groupby data of Program
                        let tempProgramResult = localGridJson[0].ProgramResult;
                        for (var i = 0; i < tempProgramResult.length; i++) {

                            if (tempProgramResult[i].UnitTypeResult.length) {
                                // grouby data of Unit Type
                                let tempUnitTypeResult = tempProgramResult[i].UnitTypeResult;
                                for (var j = 0; j < tempUnitTypeResult.length; j++) {

                                    let tempReportData = {};

                                    tempReportData.PartnerId = tempUnitTypeResult[j].PartnerId;
                                    tempReportData.ProgramId = tempUnitTypeResult[j].ProgramId;
                                    tempReportData.UnitType = tempUnitTypeResult[j].UnitType;
                                    // unit type percentage calculated
                                    if (tempUnitTypeResult.length == 1) {
                                        tempReportData.UnitTypePercent = 1;
                                        tempReportData.OnlyOneUnitType = true;
                                    }
                                    else {
                                        tempReportData.UnitTypePercent = _.toNumber(tempUnitTypeResult[j].Unit) / _.sumBy(tempUnitTypeResult, 'Unit');
                                        tempReportData.OnlyOneUnitType = false;
                                    }

                                    tempReportData.Unit = tempUnitTypeResult[j].Unit;

                                    tempProgramUnit.push(tempReportData);
                                }
                            }
                        }
                    }
                }
                //Filter Programs for Which Investment should not be shown.
                console.log("tempProgramUnit",tempProgramUnit);
                self.ProgramandUnit = self.getFilteredInvestment(tempProgramUnit); //note
                // self.ProgramandUnit = localGridJson[0].Result;
                console.log("program and unit", self.ProgramandUnit);
            }
        },

        getDistribution: function (taxDate, flgPrior) {
            const self = this;
            self.isNonPartner = false;
            let distributionAPIData = self.withFilter(
                self.BaseModelDistribution.list
            );
            
            // HOT FIX - Date Format for Distribution Date <= Tax Date
            let taxDate1 = new Date(taxDate);
            let getTaxDateYear = taxDate1.getFullYear();
            let getTaxDateMonth = taxDate1.getMonth();
            let getTaxDateDay = taxDate1.getDate();

            taxDate = new Date(getTaxDateYear, getTaxDateMonth, getTaxDateDay, 23, 59, 59);

            let getPartnerType = _.filter(distributionAPIData, function (obj) {
                return (
                    obj.PartnerId == self.criteriaData.Partner.Id &&
                    new Date(obj.DistributionDate) <= new Date(taxDate) &&
                    obj.DistributionPartnerType == "Non-Partner"
                );
            });
            
            if (getPartnerType.length) {
                self.isNonPartner = true;
                var localGridJsonNonPartner = window.linq.from(getPartnerType)
                    .groupBy("$.PartnerId", null, function (key, obj) {
                        return {
                            PartnerId: key,
                            Result: window.linq.from(obj)
                                .groupBy(
                                    "$.ProgramId",
                                    null,
                                    "{ PartnerId: $$.min('($.PartnerId)'),ProgramId: $, DistributionAmount: $$.sum('Number($.DistributionAmount)')}"
                                )
                                .toArray()
                        };
                    })
                    .toArray();                
            }

            let filteredDistribution = _.filter(distributionAPIData, function (obj) {
                return (
                    obj.PartnerId == self.criteriaData.Partner.Id &&
                    new Date(obj.DistributionDate) <= new Date(taxDate)
                );
            });
            // if(filteredDistribution) {
            //     if(filteredDistribution.length)
            //     filteredDistribution.forEach( function(item) {
            //         if(item.ProgramId == self.ExceptionProgram.Child.Id){
            //             item.ProgramId = self.ExceptionProgram.Master.Id;
            //         }                    
            //     });
            // }

            if (filteredDistribution.length) {
                var localGridJson = window.linq.from(filteredDistribution)
                    .groupBy("$.PartnerId", null, function (key, obj) {
                        return {
                            PartnerId: key,
                            Result: window.linq.from(obj)
                                .groupBy(
                                    "$.ProgramId",
                                    null,
                                    "{ PartnerId: $$.min('($.PartnerId)'),ProgramId: $, DistributionAmount: $$.sum('Number($.DistributionAmount)')}"
                                )
                                .toArray()
                        };
                    })
                    .toArray();
            }

            var localDistribution = [];
            if (!flgPrior) {
                localDistribution = self.ProgramandUnit;
            } else {
                localDistribution = self.Distribution;
            }
            let tempLocalDistribution = localDistribution;
            // Removing !self.isNonPartner as it is making Units to 0
            if (localDistribution && localGridJson) {
                if (localGridJson[0].Result.length) {
                    for (var i = 0; i < localDistribution.length; i++) {
                        let result = localGridJson[0].Result.filter(function (obj) {
                            return obj.ProgramId == localDistribution[i].ProgramId;
                        })[0];
                        if (!flgPrior) {// no prior distribution
                            if (result) { // check for Only one UnitType for Program "True", so no need to do (UnitTypePercent * DistributedAmount) 
                            // TSEV VII and TSEV VII 2.0 are considered as same Investment by Client.
                            // TSEV VII all units are to be considered as Standard and 2.0 as Supplemental.

                            if(localDistribution[i].OnlyOneUnitType) {
                                if (localDistribution[i].ProgramId == self.ExceptionProgram.Master.Id) {
                                    if(localDistribution[i].UnitType == "Supplemental") {
                                        let distData = localGridJson[0].Result.filter(function (obj) {
                                            return obj.ProgramId == self.ExceptionProgram.Child.Id;
                                        })[0];
                                        console.log("distData for tsev 2.0  unit type one",distData);
                                        distData.DistributionAmount = distData.DistributionAmount ? distData.DistributionAmount : 0;
                                        localDistribution[i].DistributionAmount =
                                            _.toNumber(distData.DistributionAmount);
                                    }
                                    else {
                                        localDistribution[i].DistributionAmount =
                                        result.DistributionAmount;
                                    }
                                }
                                else {
                                    localDistribution[i].DistributionAmount =
                                    result.DistributionAmount;
                                }


                            }// check for Only one UnitType for Program "False", so need to do (UnitTypePercent * DistributedAmount) 
                                else {
                                    if(localDistribution[i].ProgramId == self.ExceptionProgram.Master.Id) {
                                        if(localDistribution[i].UnitType == "Supplemental") {
                                            let distData = localGridJson[0].Result.filter(function (obj) {
                                                return obj.ProgramId == self.ExceptionProgram.Child.Id;
                                            })[0];
                                            console.log("distData for tsev 2.0",distData);
                                            localDistribution[i].DistributionAmount = distData.DistributionAmount;
                                        } else {
                                            localDistribution[i].DistributionAmount =
                                            _.toNumber(result.DistributionAmount);
                                        }
                                    } else {
                                        localDistribution[i].DistributionAmount =
                                        _.toNumber(result.DistributionAmount) * localDistribution[i].UnitTypePercent;
                                    }

                                }
                            } else {                                
                                localDistribution[i].DistributionAmount = 0;      
                            }
                        } else {// prior distribution
                            if (result) { // check for Only one UnitType for Program "True", so no need to do (UnitTypePercent * DistributedAmount) 
                                if (localDistribution[i].OnlyOneUnitType) {
                                    if(localDistribution[i].ProgramId == self.ExceptionProgram.Master.Id) {
                                        if(localDistribution[i].UnitType == "Supplemental") {
                                            let distData = localGridJson[0].Result.filter(function (obj) {
                                                return obj.ProgramId == self.ExceptionProgram.Child.Id;
                                            })[0];
                                            console.log("distData for tsev 2.0  unit type one",distData);
                                            distData.DistributionAmount = distData.DistributionAmount ? distData.DistributionAmount : 0;
                                            localDistribution[i].PriorDistributionAmount =
                                                _.toNumber(distData.DistributionAmount);
                                        } else {
                                            localDistribution[i].PriorDistributionAmount =
                                            result.DistributionAmount;
                                        }
                                    } else {
                                        localDistribution[i].PriorDistributionAmount =
                                        result.DistributionAmount;
                                    }

                                    // localDistribution[i].PriorDistributionAmount =
                                    //     result.DistributionAmount;
                                }// check for Only one UnitType for Program "False", so need to do (UnitTypePercent * DistributedAmount) 
                                else {
                                    if(localDistribution[i].ProgramId == self.ExceptionProgram.Master.Id) {
                                        if(localDistribution[i].UnitType == "Supplemental") {
                                            let distData = localGridJson[0].Result.filter(function (obj) {
                                                return obj.ProgramId == self.ExceptionProgram.Child.Id;
                                            })[0];
                                            console.log("distData for tsev 2.0",distData);
                                            localDistribution[i].PriorDistributionAmount = distData.DistributionAmount;
                                        } else {
                                            localDistribution[i].PriorDistributionAmount =
                                            _.toNumber(result.DistributionAmount);
                                        }
                                    } else {
                                        localDistribution[i].PriorDistributionAmount =
                                        _.toNumber(result.DistributionAmount) * localDistribution[i].UnitTypePercent;
                                    }

                                }
                            } else {  
                                localDistribution[i].PriorDistributionAmount = 0;
                            }
                        }
                    }
                    if (!flgPrior) {
                        self.Distribution = localDistribution;
                    } else {
                        self.PriorDistribution = localDistribution;
                    }
                }
            }

            // Program not Present in Transactionlog but in Distribution
            let onlyInDistribution ;

            if(localGridJson && localGridJson[0].Result.length) {

                onlyInDistribution = localGridJson[0].Result.filter(obj => 
                    !localDistribution.some(i => i.ProgramId === obj.ProgramId)
                );
                console.log('result1',onlyInDistribution);

                // TSEV VII and TSEV VII 2.0 hotfix for partners having units in only one of the program and need to show distributions
                let data;
                if(!flgPrior) {
                    for(let i = 0; i < localDistribution.length; i++)
                    {
                        data = localGridJson[0].Result.filter(function (obj) {
                            return (
                                obj.ProgramId == self.ExceptionProgram.Master.Id &&
                                localDistribution[i].ProgramId == self.ExceptionProgram.Master.Id &&
                                localDistribution[i].OnlyOneUnitType &&
                                localDistribution[i].UnitType == "Supplemental"
                            );
                        });
                        if(data) {
                            if(data.length > 0) {
                                console.log("data",data[0]);
                                onlyInDistribution.push(data[0]);
                            }
                        }
                    }
                }
            }

            // console.log("ans",ans);
            // for (var i = 0; i < localDistribution.length; i++) {
            //     onlyInDistribution = localGridJson[0].Result.filter(function (obj) {
            //         console.log("obj",JSON.stringify(obj));
            //         //let res = obj.ProgramId != localDistribution[i].ProgramId;
            //         //console.log('res',res);
            //         return (obj.ProgramId != localDistribution[i].ProgramId);
            //     });
            // }
            console.log("result",onlyInDistribution);
            if(onlyInDistribution) {
                if(onlyInDistribution.length) {
                    if (!flgPrior) {
                        let nonPartnerDistributionData = [];
                        //if (localGridJsonNonPartner[0].Result.length) {
                            onlyInDistribution.forEach(distribution => {
                                let nonPartnerDistribution = {};
                                nonPartnerDistribution.DistributionAmount = distribution.DistributionAmount;
                                nonPartnerDistribution.OnlyOneUnitType = true;
                                nonPartnerDistribution.PartnerId = distribution.PartnerId;
                                nonPartnerDistribution.ProgramId = distribution.ProgramId;
                                nonPartnerDistribution.UnitPercent = 1;
                                nonPartnerDistribution.UnitType = "";
                                nonPartnerDistribution.Unit = 0;
                                nonPartnerDistributionData.push(nonPartnerDistribution);
                            });
                        //}
                        nonPartnerDistributionData = self.getFilteredInvestment(nonPartnerDistributionData);
                        nonPartnerDistributionData.forEach(element => {
                            self.Distribution.push(element);
                        })
                        
                        console.log("distribution 2", nonPartnerDistributionData,self.Distribution);
                    }
                    else {
                        if (onlyInDistribution.length) {
                            for (var i = 0; i < localDistribution.length; i++) {
                                let result = onlyInDistribution.filter(function (obj) {
                                    return obj.ProgramId == localDistribution[i].ProgramId;
                                })[0];
    
                                if (result) {
                                    localDistribution[i].PriorDistribution = result.DistributionAmount;
                                } else {
                                    localDistribution[i].PriorDistribution = 0;
                                }
                            }
                        }
    
                        self.PriorDistribution = localDistribution;
                        console.log("Priordistribution", self.PriorDistribution);
    
                    }              
                }
            }
            // else if (self.isNonPartner && localGridJson) {
            //     if (!flgPrior) {
            //         let nonPartnerDistributionData = []
            //         if (localGridJson[0].Result.length) {
            //             localGridJson[0].Result.forEach(distribution => {
            //                 let nonPartnerDistribution = {};
            //                 nonPartnerDistribution.DistributionAmount = distribution.DistributionAmount;
            //                 nonPartnerDistribution.OnlyOneUnitType = true;
            //                 nonPartnerDistribution.PartnerId = distribution.PartnerId;
            //                 nonPartnerDistribution.ProgramId = distribution.ProgramId;
            //                 nonPartnerDistribution.UnitPercent = 1;
            //                 nonPartnerDistribution.UnitType = "";
            //                 nonPartnerDistribution.Unit = 0;
            //                 nonPartnerDistributionData.push(nonPartnerDistribution);
            //             });
            //         }
            //         self.Distribution = self.getFilteredInvestment(nonPartnerDistributionData);
            //         console.log("distribution", self.Distribution);
            //     }
            //     else {
            //         if (localGridJson[0].Result.length) {
            //             for (var i = 0; i < localDistribution.length; i++) {
            //                 let result = localGridJson[0].Result.filter(function (obj) {
            //                     return obj.ProgramId == localDistribution[i].ProgramId;
            //                 })[0];

            //                 if (result) {
            //                     localDistribution[i].PriorDistribution = result.DistributionAmount;
            //                 } else {
            //                     localDistribution[i].PriorDistribution = 0;
            //                 }
            //             }
            //         }

            //         self.PriorDistribution = localDistribution;
            //         console.log("Priordistribution", self.PriorDistribution);

            //     }

            // }
            else {
                if (!flgPrior) {
                    localDistribution.forEach(element => {
                        element.DistributionAmount = 0
                    });
                    self.Distribution = localDistribution;
                } else {
                    localDistribution.forEach(element => {
                        element.PriorDistributionAmount = 0
                    });
                    self.PriorDistribution = localDistribution;
                }
            }
        },

        getInvestment: function (investmentId) {
            const self = this;

            let programAPIData = self.withFilter(self.BaseModelProgram.list);
            let investmentAPIData = self.withFilter(self.BaseModelInvestment.list);

            let localInvestment = self.PriorDistribution;

            /*
            localInvestment = localInvestment.filter(function (obj) {
                return obj.InvestmentId == investmentId;
            })[0];
*/

            let progresult = programAPIData.filter(function (obj) {
                return obj.InvestmentId == investmentId;
            })[0];

            localInvestment = localInvestment.filter(function (obj) {
                return obj.ProgramId == progresult.Id;
            });

            if (localInvestment.length) {
                for (var i = 0; i < localInvestment.length; i++) {
                    /*
                    let result = programAPIData.filter(function (obj) {
                        return obj.Id == localInvestment[i].ProgramId;
                    })[0];
                    */
                    let result = progresult;
                    

                    if (result) {
                        localInvestment[i].InvestmentId = result.InvestmentId;
                        localInvestment[i].InvestmentInvestmentID =
                            result.InvestmentInvestmentID;
                        if (localInvestment[i].UnitType.toString().trim() == "Supplemental" || localInvestment[i].UnitType.toString().trim() == "Deal" && localInvestment[i].InvestmentId != self.ExceptionProgram.Child.InvestmentId) {
                            localInvestment[i].InvestmentTitle = result.InvestmentTitle + " (Supplemental Units) ";
                        }
                        else {
                            localInvestment[i].InvestmentTitle = result.InvestmentTitle;
                        }
                    }
                }

                for (var i = 0; i < localInvestment.length; i++) {
                    let result1 = investmentAPIData.filter(function (obj) {
                        return (
                            obj.InvestmentID == localInvestment[i].InvestmentInvestmentID
                        );
                    })[0];

                    let resultSupp = investmentAPIData.filter(function (obj) {
                        let title = obj.Title + " ";
                        return (
                            
                            title.toUpperCase() === localInvestment[i].InvestmentTitle.toUpperCase()
                        );
                    })[0]; 



                    if (result1) {

                        // const getConfig1 = item => item.InvestmentGroup;
                        // const getConfig2 = item => item.StatementOrder;
            
                        // var groupByResult = deepGroupBy(
                        //     result1,
                        //     getConfig1,
                        //     getConfig2
                        // );
                        //console.log("This is result1: ");
                        //console.log(result1);
                        //result1 = _.groupBy(result1, result1.InvestmentGroup)
                        localInvestment[i].InvestmentInvestmentGroup = //deep groupby
                            result1.InvestmentGroup;
                        localInvestment[i].InvestmentStatementOrder =
                            result1.StatementOrder;
                    if(resultSupp) {
                        localInvestment[i].InvestmentStatementOrder =
                        resultSupp.StatementOrder;
                    }
                        // Hot fix, Set investment Id of tsev vii 2.0 to 16
                        // let tsev2 = "TSEV VII (Supplemental Units) "
                        // if(localInvestment[i].InvestmentTitle.toString().trim().toLowerCase() == tsev2.toString().trim().toLowerCase()) {
                        //     localInvestment[i].InvestmentStatementOrder = 16;
                        // }


                        if (result1.HideNumberOnFMVS != null) {
                            localInvestment[i].HideNumberOnFMVS = result1.HideNumberOnFMVS;
                        }
                        else {
                            localInvestment[i].HideNumberOnFMVS = "";
                        }
                    }
                }
            }
            
            // let testInvestment = _(localInvestment)
            //                     .groupBy(item => item.InvestmentInvestmentGroup)
            //                     .orderBy(group.InvestmentStatementOrder, ["desc"])
            //                     .value();
            // console.log("Group by: ");
            // console.log(testInvestment);
            localInvestment = _.orderBy(localInvestment, ["InvestmentInvestmentGroup", "InvestmentStatementOrder"], ["desc", "asc"]);
            // localInvestment = _.chain(localInvestment)
            //                     .groupBy(item => item.InvestmentInvestmentGroup)
            //                     .map((localInvestment, InvestmentInvestmentGroup) => ({InvestmentInvestmentGroup, localInvestment}))
            //                     .sortBy(group => group.InvestmentStatementOrder)
            //                     .value();
            self.Investment = localInvestment;

            console.log("Investment", self.Investment);
        },

        getVesting: function (columnSndRcr) {
            const self = this;
            let VestingFilterQuery = {
                batchQuery: true,
                filter: function (o) {
                    return o.WorkflowStatus == "Approved"
                    //o.SpecialArrangement != 'Overridden' && 

                },
                limit: 5000
            }

            let vestingAPIData = self.withFilter(
                self.BaseModelVesting.list, VestingFilterQuery);
            //Get Remaining Vesting From Transaction(Issuance/Transfer)   
            let IssuanceQuery = {
                batchQuery: true,
                filter: function (o) {
                    return (
                        (o.WorkflowStatus == "Approved" &&
                            o.ReceiverId != 1)
                        && (o.VestingType == "Standard"
                            || (o.VestingType == 'Cliff' && !isNullOrUndefined(o.VestCliffDate)))
                    );
                }
            }
            self._getVestingFromTransactions(BaseModelIssuance, IssuanceQuery, vestingAPIData, new Date(self.taxDateToFilter))
            //Transfer datal
            let TransferQuery = {
                batchQuery: true,
                filter: function (o) {
                    return o.WorkflowStatus == "Approved" && o.VestingType != "Custom"
                }
            }
            self._getVestingFromTransactions(BaseModelTransfer, TransferQuery, vestingAPIData, new Date(self.taxDateToFilter))

            let filteredVesting;

            if (columnSndRcr == "ReceiverId") {
                filteredVesting = _.filter(vestingAPIData, function (obj) {
                    return (
                        obj.ReceiverId == self.criteriaData.Partner.Id &&
                        new Date(obj.VestedDate) <= new Date(self.taxDateToFilter)
                    );
                });
            }
            else {
                filteredVesting = _.filter(vestingAPIData, function (obj) {
                    return (
                        obj.SenderId == self.criteriaData.Partner.Id &&
                        new Date(obj.VestedDate) <= new Date(self.taxDateToFilter)
                    );
                });
            }

            var aggregateVestedData = [];

            if (filteredVesting.length) {
                var localGridJson = window.linq.from(filteredVesting)
                    .groupBy("$." + columnSndRcr, null, function (key, obj) {
                        return {
                            PartnerId: key,
                            ProgramResult: window.linq.from(obj)
                                .groupBy(
                                    "$.ProgramId",
                                    null,
                                    //"{ PartnerId: $$.min('($.ReceiverId)'),ProgramId: $, Unit: $$.sum('Number($.Unit)')}"
                                    function (key1, obj1) {
                                        return {
                                            ProgramId: key1,
                                            UnitTypeResult: window.linq.from(obj1)
                                                .groupBy(
                                                    "$.UnitType",
                                                    null,
                                                    "{ PartnerId: $$.min('($." + columnSndRcr + ")'), ProgramId: $$.min('($.ProgramId)'), UnitType: $, Unit: $$.sum('Number($.Unit)'), VestedUnit: $$.sum('Number($.VestedUnit)')}"
                                                )
                                                .toArray()
                                        };
                                    }
                                )
                                .toArray()
                        };
                    })
                    .toArray();

                if (localGridJson.length) {
                    if (localGridJson[0].ProgramResult.length) {
                        // groupBy data of Program
                        let tempProgramResult = localGridJson[0].ProgramResult;
                        for (var i = 0; i < tempProgramResult.length; i++) {

                            if (tempProgramResult[i].UnitTypeResult.length) {
                                // grouby data of Unit Type
                                let tempUnitTypeResult = tempProgramResult[i].UnitTypeResult;
                                for (var j = 0; j < tempUnitTypeResult.length; j++) {

                                    let tempVestingData = {};

                                    tempVestingData.PartnerId = tempUnitTypeResult[j].PartnerId;
                                    tempVestingData.ProgramId = tempUnitTypeResult[j].ProgramId;
                                    tempVestingData.UnitType = tempUnitTypeResult[j].UnitType;
                                    tempVestingData.Unit = tempUnitTypeResult[j].Unit;
                                    tempVestingData.VestedUnit = tempUnitTypeResult[j].VestedUnit;

                                    aggregateVestedData.push(tempVestingData);
                                }
                            }
                        }
                    }
                }
            }
            console.log("aggregateVestedData",aggregateVestedData);
            return aggregateVestedData;
        },

        calculateVestingPercent: function (aggregateVestedData) {
            let self = this;
            let localVesting = self.Investment;

            let rtnVestingPercent = [];

            if (localVesting.length && aggregateVestedData.length) {
                for (var i = 0; i < localVesting.length; i++) {
                    let result = aggregateVestedData.filter(function (obj) {
                        return (obj.ProgramId == localVesting[i].ProgramId &&
                            obj.UnitType == localVesting[i].UnitType);
                    })[0];

                    let outVestingPercent = "";

                    if (result) {
                        //When denominator is zero, vesting% is N/A
                        if (this.getZeros(result.Unit) == 0) {
                            outVestingPercent = "N/A";
                        } 
                        else {
                            outVestingPercent = _.toNumber(result.VestedUnit) / _.toNumber(result.Unit);
                        }

                        // Hotfix : Transfer units 
                        // console.log("Transfer Status",this.getTransferStatus());
                        // if(this.getTransferStatus()) {
                        //     if(this.getZeros(result.Unit) == 0) {
                        //         outVestingPercent = "N/A";
                        //     } 
                        // }

                    }
                    else {
                        let result = aggregateVestedData.filter(function (obj) {
                            return (obj.ProgramId == self.ExceptionProgram.Child.Id &&
                                obj.UnitType == localVesting[i].UnitType && localVesting[i].ProgramId == self.ExceptionProgram.Master.Id);
                        })[0];

                        if (result) {
                            //When denominator is zero, vesting% is N/A
                            if (this.getZeros(result.Unit) == 0) {
                                outVestingPercent = "N/A";
                            } 
                            else {
                                outVestingPercent = _.toNumber(result.VestedUnit) / _.toNumber(result.Unit);
                            }
                        }
                        else
                        {
                            outVestingPercent = 0;
                        }
                    }

                    rtnVestingPercent.push(outVestingPercent)
                }
            }

            // self.Vesting = localVesting;
            //console.log(columnSndRcr, rtnVestingPercent);

            return rtnVestingPercent;
        },

        calcVesting: function () {
            const self = this;

            let lclVesting = self.Investment;

            let rcrPartnerList = self.getVesting("ReceiverId");
            let sndPartnerList = self.getVesting("SenderId");
            let calcVestPercentage = "";
            console.log("rcrPartnerList", rcrPartnerList);
            console.log("sndPartnerList", sndPartnerList);
            if (sndPartnerList.length) {
                for (let i = 0; i < rcrPartnerList.length; i++) {
                    if (rcrPartnerList[i].PartnerId) {
                        let result = sndPartnerList.filter(function (obj) {
                            if (obj.ProgramId && obj.PartnerId && obj.UnitType) {
                                return (

                                    obj.PartnerId ==
                                    rcrPartnerList[i].PartnerId &&
                                    obj.ProgramId ==
                                    rcrPartnerList[i].ProgramId &&
                                    obj.UnitType ==
                                    rcrPartnerList[i].UnitType
                                );
                            }
                        })[0];
                        if (result) {
                            rcrPartnerList[i].Unit = rcrPartnerList[i].Unit - result.Unit;
                            rcrPartnerList[i].VestedUnit = rcrPartnerList[i].VestedUnit - result.VestedUnit;
                            //excelData[i].PartnerId=result.Id;
                        }
                    }
                }

            }
            // Override Logic
            let overrideVestQuery = {
                batchQuery: true,
                filter: function (o) {
                    return (
                        o.BusinessEvent == "Vesting" &&
                        (o.WorkflowStatus == "Approved" ||
                            o.WorkflowStatus == "Correction Pending" ||
                            o.WorkflowStatus == "Correction Approved") &&
                        //o.SpecialArrangement == "Overridden" &&
                        o.ReceiverId == self.criteriaData.Partner.Id &&
                        moment(o.VestedDate) < moment(new Date(self.taxDateToFilter))
                    );
                }
            };
            let VestingOverrideResult = this.withFilter(BaseModelVesting.list, overrideVestQuery);
            if (!isNullOrUndefined(VestingOverrideResult) && VestingOverrideResult.length) {
                for (let i = 0; i < rcrPartnerList.length; i++) {
                    if (rcrPartnerList[i].PartnerId) {
                        let result = VestingOverrideResult.filter(function (obj) {
                            if (obj.ProgramId && obj.UnitType) {
                                return (

                                    //                                     obj.PartnerId ==
                                    //                                     rcrPartnerList[i].PartnerId &&
                                    obj.ProgramId ==
                                    rcrPartnerList[i].ProgramId &&
                                    obj.UnitType ==
                                    rcrPartnerList[i].UnitType
                                );
                            }
                        });
                        if (!isNullOrUndefined(result) && result.length > 0) {
                            // rcrPartnerList[i].Unit = result.Unit;
                            rcrPartnerList[i].VestedUnit = 0;
                            for (let j = 0; j < result.length; j++) {
                                rcrPartnerList[i].VestedUnit = rcrPartnerList[i].VestedUnit + result[j].VestedUnit;
                            }
                            //excelData[i].PartnerId=result.Id;
                        }
                    }
                }
            }
            let aggregatedResult = []
            //Aggregate By Program and UnitType
            const getConfig1 = item => item.ProgramId;
            const getConfig2 = item => item.UnitType;
            let groupByResult = deepGroupBy(
                VestingOverrideResult,
                getConfig1,
                getConfig2
            );
            Object.keys(groupByResult).forEach(function (programKey, programIndex) {
                let programResult = groupByResult[programKey];
                Object.keys(programResult).forEach(function (unitTypeKey, unitTypeIndex) {
                    let unitTypeResult = programResult[unitTypeKey];
                    let row = {}
                    row.PartnerId = unitTypeResult[0].ReceiverId
                    row.ReceiverId = unitTypeResult[0].ReceiverId
                    row.ProgramId = unitTypeResult[0].ProgramId
                    row.Unit = _.sumBy(unitTypeResult, 'Unit');
                    row.UnitType =  unitTypeResult[0].UnitType;
                    row.VestedUnit = _.sumBy(unitTypeResult, 'VestedUnit');
                    //row.Percentage = unitTypeResult[0].Percentage;
                    row.Percentage = _.sumBy(unitTypeResult, 'Percentage');
                    aggregatedResult.push(row)
                })

            });

            //Get Partner Row Based on Id
            let partnerId = self.criteriaData.Partner.Id;
            let PartnerInfo = self.withFilter(self.BaseModelPartner.list, { filter: "Id eq " + partnerId });

            //let orderedResult=_.reverse(_.sortBy(VestingOverrideResult, [function(o) { return o.Modified; }]))
            //Replcae Original Array with Override Data.
            rcrPartnerList.forEach(vestingRow => {
                let index = aggregatedResult.findIndex(function (ele) {
                    return ele.ProgramId == vestingRow.ProgramId && (ele.ReceiverId == vestingRow.PartnerId || ele.ReceiverId == vestingRow.ReceiverId)
                        && ele.UnitType == vestingRow.UnitType
                })
                if (index >= 0) {
                    vestingRow.VestedUnit = aggregatedResult[index].VestedUnit
                    //vestingRow.Percentage=aggregatedResult[index].Percentage
                    vestingRow.Unit = vestingRow.VestedUnit / aggregatedResult[index].Percentage
                    if (PartnerInfo[0].VestingAcceleration && PartnerInfo[0].VestingAcceleration.toLowerCase() == "yes")
                    {
                        vestingRow.VestedUnit = vestingRow.Unit;
                    }
                }
            });

            calcVestPercentage = self.calculateVestingPercent(rcrPartnerList);



 

            if (lclVesting.length) {

                for (var i = 0; i < lclVesting.length; i++) {
                    //Check if Partner Boughout or not
                    if (PartnerInfo && PartnerInfo[0] && PartnerInfo[0].BoughtOut && PartnerInfo[0].BoughtOut.toLowerCase() == "yes") {
                        //For Each Investment Find the Program\
                        //For Each Program Find If Partner has Units 
                        let partnerRemainingUnits = 0
                        let Program = self.withFilter(self.BaseModelProgram.list, { filter: "InvestmentId eq " + lclVesting[i].InvestmentId });
                        if (Program && Program[0]) {
                            //Get the Remaining Units for the Partner and the Program
                            let response = this.withFilter(self.BaseModelUnitRunningTotal.list, {
                                filter: `ProgramId eq ${Program[0].Id} and PartnerId eq ${partnerId}`
                            });
                            if (response.length > 0) {
                                response.forEach(function (obj) {
                                    partnerRemainingUnits = partnerRemainingUnits + obj["Unit"];
                                });
                            }
                        }
                        if (partnerRemainingUnits > 0) {
                            lclVesting[i].VestingPercent = "1";
                        } else {
                            lclVesting[i].VestingPercent = "N/A";
                        }

                    } else {
                        if (rcrPartnerList.length && rcrPartnerList[i] == "N/A") {
                            lclVesting[i].VestingPercent = "N/A";
                        }
                        else {
                            lclVesting[i].VestingPercent = calcVestPercentage[i];
                        }
                    }
                }
            }
            self.Vesting = lclVesting;
            console.log("vesting", self.Vesting);
        },

        getValuation: function (investmentId, taxYearQuarter, flgPrior) {
            const self = this;

            let valuationAPIData = self.withFilter(
                self.BaseModelAllocation.list
            );

            let filteredValuation = _.filter(valuationAPIData, function (obj) {
                return (
                    obj.PartnerId == self.criteriaData.Partner.Id &&
                    obj.TaxYearQuarter == taxYearQuarter && 
                    obj.InvestmentId == investmentId
                );
            });

            var localValuation = [];
            if (!flgPrior) {
                //localValuation = self.Vesting;
                localValuation = self.Investment;
            } else {
                localValuation = self.Valuation;
            }
            
            if (filteredValuation.length) {
                /*if (!localValuation)
                {
                    localValuation = filteredValuation;

                    //localValuation[0].InvestmentId = filteredValuation[0].InvestmentId;
                    //localValuation[0].ProjectedValue = filteredValuation[0].ProjectedValue;
                    //localValuation[0].CurrentValue = filteredValuation[0].CurrentValue;
                }
                else
                {*/

                for (var i = 0; i < localValuation.length; i++) {
                    let result = filteredValuation.filter(function (obj) {
                        return obj.InvestmentId == localValuation[i].InvestmentId;
                    })[0];

                    let result1 = filteredValuation.filter(function (obj) {
                        return obj.InvestmentId == localValuation[i].InvestmentId;
                    });
                    if(result) {
                       // console.log("Filtered Valuation result",result);
                        result.ProjectedValue = _.sumBy(result1,"ProjectedValue");
                        result.CurrentValue = _.sumBy(result1,"CurrentValue");
                        //console.log("Filtered Valuation result1",result1);
                    }

                    if (!flgPrior) {// no prior valuation
                        if (result) {// check for Only one UnitType for Program "True", so no need to do (UnitTypePercent * ProjectedValue) & same for other column 
                            if (localValuation[i].OnlyOneUnitType) {

                                // TSEV VII and TSEV VII 2.0 hotfix for partners having units in only one of the program and need to show distributions
                                if(localValuation[i].InvestmentId == self.ExceptionProgram.Master.InvestmentId && localValuation[i].UnitType.length == 0)
                                {   
                                    console.log("TSEV VII");
                                    localValuation[i].ProjectedValue = 0;
                                    localValuation[i].CurrentValue = 0;  
                                } else {
                                    localValuation[i].ProjectedValue = result.ProjectedValue;
                                    localValuation[i].CurrentValue = result.CurrentValue;
                                }

                            }// check for Only one UnitType for Program "False", so need to do (UnitTypePercent *  ProjectedValue) & same for other column
                            else {
                                localValuation[i].ProjectedValue =
                                    (_.toNumber(result.ProjectedValue) * localValuation[i].UnitTypePercent);
                                localValuation[i].CurrentValue =
                                    (_.toNumber(result.CurrentValue) * localValuation[i].UnitTypePercent);
                            }

                        } else {
                            localValuation[i].ProjectedValue = 0;
                            localValuation[i].CurrentValue = 0;
                        }
                    } else { // prior valuation 
                        if (result) {// check for Only one UnitType for Program "True", so no need to do (UnitTypePercent * ProjectedValue) & same for other column 
                            if (localValuation[i].OnlyOneUnitType) {

                                // TSEV VII and TSEV VII 2.0 hotfix for partners having units in only one of the program and need to show distributions
                                if(localValuation[i].InvestmentId == self.ExceptionProgram.Master.InvestmentId && localValuation[i].UnitType.length == 0)
                                {
                                    console.log("TSEV VII");
                                    localValuation[i].PriorProjectedValue = 0;
                                    localValuation[i].PriorCurrentValue = 0; 
                                } else {
                                    localValuation[i].PriorProjectedValue = result.ProjectedValue;
                                    localValuation[i].PriorCurrentValue = result.CurrentValue;
                                }
                                // localValuation[i].PriorProjectedValue = result.ProjectedValue;
                                // localValuation[i].PriorCurrentValue = result.CurrentValue;
                            }// check for Only one UnitType for Program "False", so need to do (UnitTypePercent *  ProjectedValue) & same for other column
                            else {
                                localValuation[i].PriorProjectedValue =
                                    (_.toNumber(result.ProjectedValue) * localValuation[i].UnitTypePercent);
                                localValuation[i].PriorCurrentValue =
                                    (_.toNumber(result.CurrentValue) * localValuation[i].UnitTypePercent);
                            }
                        } else {
                            localValuation[i].PriorProjectedValue = NaN;
                            localValuation[i].PriorCurrentValue = NaN;
                        }
                    }
                }
            //}
                if (!flgPrior) {
                    self.Valuation = localValuation;
                    console.log("Valuation", self.Valuation);
                } else {
                    self.PriorValuation = localValuation;
                    console.log("PriorValuation", self.PriorValuation);
                }
            }
            else {
                for (var i = 0; i < localValuation.length; i++) {
                    if (!flgPrior) {
                        localValuation[i].ProjectedValue = 0;
                        localValuation[i].CurrentValue = 0;
                        self.Valuation = localValuation;
                    } else {
                        localValuation[i].PriorProjectedValue = 0;
                        localValuation[i].PriorCurrentValue = 0;
                        self.PriorValuation = localValuation;
                    }
                }
            }
        },
        getTaxandPriorTaxPeriod: function(taxYear, taxQuarter) {
            if (taxQuarter == "Q1") {
              return taxYear + "/3/31";
            } else if (taxQuarter == "Q2") {
              return taxYear + "/6/30";
            } else if (taxQuarter == "Q3") {
              return taxYear + "/9/30";
            } else {
              return taxYear + "/12/31";
            }
        },

        getTaxPeriod: function (selectedDate, priorYearYesNo) {

            let taxDate1 = new Date(selectedDate);
            let getTaxDateYear = taxDate1.getFullYear();
            let getTaxDateMonth = taxDate1.getMonth();
            let getTaxDateDay = taxDate1.getDate();
        
            let taxDate = new Date(getTaxDateYear, getTaxDateMonth, getTaxDateDay, 23, 59, 59);

            if (!priorYearYesNo)
            {
                //if (getTaxDateMonth >= 0 && getTaxDateMonth < 6)
                if (getTaxDateMonth >= 3 && getTaxDateMonth < 9)
                {
                    //this.criteriaData.TaxPeriod = (getTaxDateYear-1) +" Q3";
                    this.criteriaData.TaxPeriod = (getTaxDateYear) +" Q1";
                }
                else
                {
                    //this.criteriaData.TaxPeriod = (getTaxDateYear) +" Q1";
                    if (getTaxDateMonth >= 9 && getTaxDateMonth < 12)
                    {
                        this.criteriaData.TaxPeriod = (getTaxDateYear) +" Q3";
                    }
                    else
                    {
                        this.criteriaData.TaxPeriod = (getTaxDateYear-1) +" Q3";
                    }
                }

            }
            else
            {
                //if (getTaxDateMonth >= 0 && getTaxDateMonth < 6)
                if (getTaxDateMonth >= 3 && getTaxDateMonth < 9)
                {
                    //this.criteriaData.PriorTaxPeriod = (getTaxDateYear-1) +" Q1";
                    this.criteriaData.PriorTaxPeriod = (getTaxDateYear-1) +" Q3";
                }
                else
                {
                    //this.criteriaData.PriorTaxPeriod = (getTaxDateYear-1) +" Q3";
                    if (getTaxDateMonth >= 9 && getTaxDateMonth < 12)
                    {
                        this.criteriaData.PriorTaxPeriod = (getTaxDateYear) +" Q1";
                    }
                    else
                    {
                        this.criteriaData.PriorTaxPeriod = (getTaxDateYear-1) +" Q1";
                    }

                }
                //self.priorTaxPeriod = "2023 Q1";

            }

        },

        //function will take in partnerid, investmentid and date, will figure out the needed data and return to caller
        formEUMGridData: function (partnerId, investmentId, selectedDate) {
            const self = this;

            self.getTaxPeriod(selectedDate, false);
            self.getTaxPeriod(selectedDate, true);
            
            self.criteriaData.Partner.Id = partnerId;
            //self.criteriaData.TaxPeriod = "2023 Q3";
            //self.priorTaxPeriod = "2023 Q1";
            //self.criteriaData.PriorTaxPeriod = "2023 Q1";

            let selectedTaxPeriod = _.split(
                self.criteriaData.TaxPeriod.toString(),
                " "
              );
      
              let selectedPriorTaxPeriod = _.split(
                self.criteriaData.PriorTaxPeriod.toString(),
                " "
              );
      
              // pervious year of taxperiod  and  qauter of priortaxperiod
              self.taxDateToFilter = self.getTaxandPriorTaxPeriod(
                selectedTaxPeriod[0],
                selectedTaxPeriod[1]
              );
      
              self.priorTaxPeriod = self.criteriaData.PriorTaxPeriod;
      
              self.priorTaxDateToFilter = self.getTaxandPriorTaxPeriod(
                selectedPriorTaxPeriod[0],
                selectedPriorTaxPeriod[1]
              );
            console.log(self.criteriaData, "FilterData");
            console.log(self.taxDateToFilter, "taxdate");
            console.log(self.priorTaxPeriod, "Prior Tax Period");
            console.log(self.priorTaxDateToFilter, "Prior Tax date");

            let InvestmentValuationAPIData = self.withFilter(
                self.BaseInvestmentValuation.list
            )

            self.curInvestment = _.filter(InvestmentValuationAPIData, function(obj) {
                return (
                    obj.TaxYearQuarter === self.criteriaData.TaxPeriod &&
                    obj.InvestmentId == investmentId
                )
            });


            self.getProgramandUnit();
            self.getDistribution(self.taxDateToFilter);
            self.getDistribution(self.priorTaxDateToFilter, true);
            self.getInvestment(investmentId);
            //self.calcVesting();
            self.getValuation(investmentId, self.criteriaData.TaxPeriod);
            self.getValuation(investmentId, self.priorTaxPeriod, true);

            self.EUMProgramTypeGridData = [];
            self.SortedEUMProgramTypeGridData = [];
            self.displayEUM = true;
            function t(){console.log("Timeout")};
            setTimeout(t(),2000);
            if (self.PriorValuation.length) {

                for (var i = 0; i < self.PriorValuation.length; i++) {

                   if (self.PriorValuation[i].InvestmentId == investmentId) 
                    {

                    let localEUMProgramTypeGridData = {};
                    // console.log("self.PriorValuation[i]",self.PriorValuation[i]);
                    // console.log("localEUMProgramTypeGridData",localEUMProgramTypeGridData);
                    localEUMProgramTypeGridData.InvestmentGroup = "";
                    localEUMProgramTypeGridData.InvestmentGroup = self.PriorValuation[i]["InvestmentInvestmentGroup"];
                    localEUMProgramTypeGridData.InvestmentID = self.PriorValuation[i].InvestmentInvestmentID;
                    localEUMProgramTypeGridData.Investment = self.PriorValuation[i].InvestmentTitle;
                    localEUMProgramTypeGridData.InvestmentOrder = self.PriorValuation[i].InvestmentStatementOrder;
                    localEUMProgramTypeGridData.HideNumberOnFMVS = self.PriorValuation[i].HideNumberOnFMVS;
                    localEUMProgramTypeGridData.Units = self.PriorValuation[i].Unit;
                    localEUMProgramTypeGridData.VestedPercent = (self.PriorValuation[i].VestingPercent ? self.PriorValuation[i].VestingPercent : 0);
                    localEUMProgramTypeGridData.PreviousUnitDistribution = _.toNumber(self.PriorValuation[i].DistributionAmount);
                    localEUMProgramTypeGridData.ProjectedUnrealizedValue = _.toNumber(self.PriorValuation[i].ProjectedValue);
                    
                    if (self.curInvestment != null)
                    {
                        if (self.curInvestment.length > 0)
                        {
                           localEUMProgramTypeGridData.ProgProjectedValue = _.toNumber(self.curInvestment[0].ProjectedValue);
                           localEUMProgramTypeGridData.ProgCurrentValue = _.toNumber(self.curInvestment[0].CurrentValue);
                        }
                    }



            
                    if(isNaN(localEUMProgramTypeGridData.ProjectedUnrealizedValue)) {
                        localEUMProgramTypeGridData.ProjectedUnrealizedValue = "-";
                    }

                    // PotentialPreTaxValue = DistributionAmount + ProjectedValue
                    localEUMProgramTypeGridData.PotentialPreTaxValue =
                        _.toNumber(self.PriorValuation[i].DistributionAmount) +
                        _.toNumber(self.PriorValuation[i].ProjectedValue);

                    localEUMProgramTypeGridData.TotalPotentialPreTaxValue =
                        _.toNumber(localEUMProgramTypeGridData.PotentialPreTaxValue);

                    if(isNaN(localEUMProgramTypeGridData.TotalPotentialPreTaxValue)) {
                        localEUMProgramTypeGridData.TotalPotentialPreTaxValue = "-";
                    }

                    // PriorPotentialPreTaxValue = PriorDistributionAmount + PriorProjectedValue
                    localEUMProgramTypeGridData.PriorPotentialPreTaxValue =
                        _.toNumber(
                            isNaN((self.PriorValuation[i].PriorDistributionAmount)) ? 0 : _.toNumber(self.PriorValuation[i].PriorDistributionAmount)
                        ) +
                        _.toNumber(
                            isNaN(self.PriorValuation[i].PriorProjectedValue) ? 0 : _.toNumber(self.PriorValuation[i].PriorProjectedValue)
                        );
                    
                    
                    // PotentialPreTaxChange = (PotentialPreTaxValue  - PriorPotentialPreTaxValue)  / PriorPotentialPreTaxValue

                    // When both PotentialPreTaxValue are NaN set as "-"

                    // if((
                    //     isNaN(localEUMProgramTypeGridData.PriorPotentialPreTaxValue) &&
                    //     isNaN(localEUMProgramTypeGridData.PotentialPreTaxValue) 
                    //    )||
                    //    localEUMProgramTypeGridData.PriorPotentialPreTaxValue == 0 &&
                    //    localEUMProgramTypeGridData.PotentialPreTaxValue == 0 
                    //    ) {
                    //     localEUMProgramTypeGridData.TotalPotentialPreTaxValuePercentChange = "-";
                    // }

                    // When denominator is zero, TotalPotentialPreTaxValuePercentChange is N/A
                    // if (_.toNumber(localEUMProgramTypeGridData.PriorPotentialPreTaxValue) == 0) {
                    //     localEUMProgramTypeGridData.TotalPotentialPreTaxValuePercentChange = "N/A"
                    // } 

                    if (_.toNumber(localEUMProgramTypeGridData.PriorPotentialPreTaxValue) == 0) {

                        // if(self.PriorValuation[i].PriorProjectedValue == 0 && self.PriorValuation[i].PriorDistributionAmount != 0) {
                        //     localEUMProgramTypeGridData.TotalPotentialPreTaxValuePercentChange = 0;
                        // } else {
                        //     localEUMProgramTypeGridData.TotalPotentialPreTaxValuePercentChange = "N/A";
                        // }

                        // if(isNaN(self.PriorValuation[i].PriorCurrentValue)) {
                        //     localEUMProgramTypeGridData.TotalPotentialPreTaxValuePercentChange = "N/A";
                        // } else {
                        //     localEUMProgramTypeGridData.TotalPotentialPreTaxValuePercentChange = 0;
                        // }

                        // New Logic 
                        // If Both Prior and Current CV is 0 => 0%
                        // If Prior CV is 0 => N/A
                        if((isNaN(self.PriorValuation[i].PriorProjectedValue) ||_.toNumber(self.PriorValuation[i].PriorProjectedValue) == 0) 
                            && _.toNumber(localEUMProgramTypeGridData.PotentialPreTaxValue) == 0) {
                            localEUMProgramTypeGridData.TotalPotentialPreTaxValuePercentChange = 0;
                        } else {
                            localEUMProgramTypeGridData.TotalPotentialPreTaxValuePercentChange = "N/A";
                        }


                        // if(isNaN(self.PriorValuation[i].PriorDistributionAmount)) {
                        //     localEUMProgramTypeGridData.TotalPotentialPreTaxValuePercentChange = "N/A";
                        // } else {
                        //     localEUMProgramTypeGridData.TotalPotentialPreTaxValuePercentChange = 0;
                        // }
                        // if(self.PriorValuation[i].PriorProjectedValue == 0 && !isNaN((self.PriorValuation[i].PriorDistributionAmount)) ) {
                        //     localEUMProgramTypeGridData.TotalPotentialPreTaxValuePercentChange = 0;
                        // }  
                        // // else if(self.PriorValuation[i].PriorProjectedValue == 0 && _.toNumber(self.PriorValuation[i].PriorDistributionAmount) == 0) {
                        // //     localEUMProgramTypeGridData.TotalPotentialPreTaxValuePercentChange = 0;
                        // // }
                        // else {
                        //     localEUMProgramTypeGridData.TotalPotentialPreTaxValuePercentChange = "N/A";
                        // }                                              
                    } 
                    else {
                        localEUMProgramTypeGridData.TotalPotentialPreTaxValuePercentChange =
                            (_.toNumber(localEUMProgramTypeGridData.PotentialPreTaxValue) -
                                _.toNumber(
                                    localEUMProgramTypeGridData.PriorPotentialPreTaxValue
                                )) /
                            _.toNumber(localEUMProgramTypeGridData.PriorPotentialPreTaxValue);
                    }

                    localEUMProgramTypeGridData.CurrentValue =
                        _.toNumber(self.PriorValuation[i].CurrentValue);

                    if(isNaN(localEUMProgramTypeGridData.CurrentValue)) {
                        localEUMProgramTypeGridData.CurrentValue = "-"
                    }

                    // CurrentPreTaxValue = DistributionAmount  + CurrentValue
                    localEUMProgramTypeGridData.CurrentPreTaxValue =
                    _.toNumber(self.PriorValuation[i].DistributionAmount) +
                    _.toNumber(self.PriorValuation[i].CurrentValue);

                    localEUMProgramTypeGridData.TotalCurrentPreTaxValue =
                        _.toNumber(localEUMProgramTypeGridData.CurrentPreTaxValue);

                    // if(isNaN(localEUMProgramTypeGridData.TotalCurrentPreTaxValue)) {
                    //     localEUMProgramTypeGridData.TotalCurrentPreTaxValue = "-" 
                    // }

                    // PriorCurrentPreTaxValue = PriorDistributionAmount + PriorCurrentValue
                    localEUMProgramTypeGridData.PriorCurrentPreTaxValue =
                        _.toNumber(
                            isNaN((self.PriorValuation[i].PriorDistributionAmount)) ? 0 : _.toNumber(self.PriorValuation[i].PriorDistributionAmount)
                        ) +
                        _.toNumber(
                            isNaN(self.PriorValuation[i].PriorCurrentValue) ? 0 : _.toNumber(self.PriorValuation[i].PriorCurrentValue)
                        );

                    // CurrentPreTaxChange = (CurrentPreTaxValue  - PriorCurrentPreTaxValue  ) / PriorCurrentPreTaxValue

                    // When both numerator is NaN set -
                    // if(isNaN(localEUMProgramTypeGridData.PriorCurrentPreTaxValue) &&
                    //     isNaN(localEUMProgramTypeGridData.CurrentPreTaxValue)) {
                    //     localEUMProgramTypeGridData.TotalCurrentPreTaxValuePercentChange = "-";
                    // }

                    // When denominator is zero, TotalCurrentPreTaxValuePercentChange is N/A
                    // if (_.toNumber(localEUMProgramTypeGridData.PriorCurrentPreTaxValue) == 0) {
                    //     localEUMProgramTypeGridData.TotalCurrentPreTaxValuePercentChange = "N/A"
                    // } 

                    // console.log("localEUMProgramTypeGridData.PriorPotentialPreTaxValue",localEUMProgramTypeGridData.Investment);
                    // console.log("localEUMProgramTypeGridData.PriorPotentialPreTaxValue",localEUMProgramTypeGridData.PriorPotentialPreTaxValue,
                    // localEUMProgramTypeGridData.PriorCurrentPreTaxValue);

                    if (_.toNumber(localEUMProgramTypeGridData.PriorCurrentPreTaxValue) == 0) {

                        // if(self.PriorValuation[i].PriorCurrentValue == 0 && self.PriorValuation[i].PriorDistributionAmount != 0) {
                        //     localEUMProgramTypeGridData.TotalCurrentPreTaxValuePercentChange = 0;
                        // } else {
                        //     localEUMProgramTypeGridData.TotalCurrentPreTaxValuePercentChange = "N/A";
                        // }

                        // if(isNaN(self.PriorValuation[i].PriorCurrentValue)) {
                        //     localEUMProgramTypeGridData.TotalCurrentPreTaxValuePercentChange = "N/A";
                        // } else {
                        //     localEUMProgramTypeGridData.TotalCurrentPreTaxValuePercentChange = 0;
                        // }

                        // New Logic 
                        // If Both Prior and Current CV is 0 => 0%
                        // If Prior CV is 0 => N/A
                        if((isNaN(self.PriorValuation[i].PriorCurrentValue) ||_.toNumber(self.PriorValuation[i].PriorCurrentValue) == 0) 
                            && _.toNumber(localEUMProgramTypeGridData.CurrentValue) == 0) {
                            localEUMProgramTypeGridData.TotalCurrentPreTaxValuePercentChange = 0;
                        } else {
                            localEUMProgramTypeGridData.TotalCurrentPreTaxValuePercentChange = "N/A";
                        }



                        // if(isNaN(self.PriorValuation[i].PriorDistributionAmount)) {
                        //     localEUMProgramTypeGridData.TotalCurrentPreTaxValuePercentChange = "N/A";
                        // } else {
                        //     localEUMProgramTypeGridData.TotalCurrentPreTaxValuePercentChange = 0;
                        // }

                        // if(self.PriorValuation[i].PriorCurrentValue == 0 && !isNaN((self.PriorValuation[i].PriorDistributionAmount)) ) {
                        //     localEUMProgramTypeGridData.TotalCurrentPreTaxValuePercentChange = 0;
                        // } 
                        // // else if(_.toNumber(self.PriorValuation[i].PriorDistributionAmount) == 0) {
                        // //     if(self.PriorValuation[i].PriorCurrentValue)
                        // //     localEUMProgramTypeGridData.TotalPotentialPreTaxValuePercentChange = 0;
                        // // } 
                        // else {
                        //     localEUMProgramTypeGridData.TotalCurrentPreTaxValuePercentChange = "N/A";
                        // }                          
                    } 
                    else {
                        localEUMProgramTypeGridData.TotalCurrentPreTaxValuePercentChange =
                            (_.toNumber(localEUMProgramTypeGridData.CurrentPreTaxValue) -
                                _.toNumber(
                                    localEUMProgramTypeGridData.PriorCurrentPreTaxValue
                                )) /
                            _.toNumber(localEUMProgramTypeGridData.PriorCurrentPreTaxValue);
                    }
                    //console.log('Previous Unit Distribution: ', localEUMProgramTypeGridData.PreviousUnitDistribution + ' | ' + localEUMProgramTypeGridData.PreviousUnitDistribution.toFixed(0));
                    // Hotfix : Zero Datas Doesn't have to be displayed
                    let conditionEUMProgramZero = Math.floor(localEUMProgramTypeGridData.Units) > 0 || Math.floor(localEUMProgramTypeGridData.PreviousUnitDistribution) > 0 || Math.floor(localEUMProgramTypeGridData.ProjectedUnrealizedValue) > 0 || Math.floor(localEUMProgramTypeGridData.CurrentValue) > 0; 
                    if (conditionEUMProgramZero) {
                       self.SortedEUMProgramTypeGridData.push(localEUMProgramTypeGridData);
                    }
                }

                }

                

            }


            // Hotfix : Remove Investments where Units and Distribution is 0
            // if(this.getTransferStatus()) {
                let filteredEUMProgramTypeGridData = self.SortedEUMProgramTypeGridData.filter(obj => {
                    return (this.getZeros(obj.Units) != 0 || obj.PreviousUnitDistribution != 0)
                })
                console.log("filteredEUMProgramTypeGridData",filteredEUMProgramTypeGridData);
                if(filteredEUMProgramTypeGridData && filteredEUMProgramTypeGridData.length > 0) {
                    self.SortedEUMProgramTypeGridData = filteredEUMProgramTypeGridData;
                }
            // }

            self.EUMProgramTypeGridData = _.sortBy(self.SortedEUMProgramTypeGridData, ['InvestmentOrder']);

            // Make all the columns 0 if Hide Number on FMVS is true. Then only the total row will have correct value for all columns.
            
            if (self.EUMProgramTypeGridData.length > 0) {
                self.EUMProgramTypeGridData = this.useInvestmentHideNumberOnFMVS(self.EUMProgramTypeGridData, 0, "EUM");
            }
            

            let PreviousUnitDistributionTotal = _.sumBy(self.EUMProgramTypeGridData, "PreviousUnitDistribution");
            let ProjectedUnrealizedValueTotal = _.sumBy(self.EUMProgramTypeGridData, "ProjectedUnrealizedValue");
            let TotalPotentialPreTaxValueTotal = _.sumBy(self.EUMProgramTypeGridData, "TotalPotentialPreTaxValue");
            let CurrentValueTotal = _.sumBy(self.EUMProgramTypeGridData, "CurrentValue");
            let TotalCurrentPreTaxValueTotal = _.sumBy(self.EUMProgramTypeGridData, "TotalCurrentPreTaxValue");

            var total = {
                "IndexGroup": 1,
                "PreviousUnitDistributionTotal": PreviousUnitDistributionTotal,
                "ProjectedUnrealizedValueTotal": ProjectedUnrealizedValueTotal,
                "TotalPotentialPreTaxValueTotal": TotalPotentialPreTaxValueTotal,
                "CurrentValueTotal": CurrentValueTotal,
                "TotalCurrentPreTaxValueTotal": TotalCurrentPreTaxValueTotal
            };

            // To display "-" in Report.
            // if (self.EUMProgramTypeGridData.length > 0) {
            //     self.EUMProgramTypeGridData = this.useInvestmentHideNumberOnFMVS(self.EUMProgramTypeGridData, "&#8209;", "EUM");
            // }

            self.EUMProgramTypeGridPdfData = [];
            let obj = _.groupBy(self.EUMProgramTypeGridData, "InvestmentGroup");
            Object.keys(obj).forEach((key, val) => {
                //console.log("group",obj,key);
                self.EUMProgramTypeGridPdfData.push({
                    "InvestmentGroup": obj[key][0], "IndexGroup": 0,
                });
                self.EUMProgramTypeGridPdfData.push.apply(self.EUMProgramTypeGridPdfData, obj[key]);
            });
            if (self.EUMProgramTypeGridPdfData.length != 0)
                self.EUMProgramTypeGridPdfData.push(total);

            if (self.EUMProgramTypeGridPdfData.length != 0)
                return self.EUMProgramTypeGridPdfData;
        },


        getContributionDistributionValuation: function (taxYearQuarter, flgPrior) {
                const self = this;

            let directInvestmentValuationAPIData = self.withFilter(
                self.BaseModelDirectInvestmentValuation.list
            );

            let filteredDirectInvestmentValuation = _.filter(
                directInvestmentValuationAPIData,
                function (obj) {
                    return (
                        obj.PartnerId == self.criteriaData.Partner.Id &&
                        obj.TaxYearQuarter == taxYearQuarter
                    );
                }
            );

            var localContribution = [];
            if (filteredDirectInvestmentValuation.length) {
                if (!flgPrior) {
                    localContribution = [];

                    for (var i = 0; i < filteredDirectInvestmentValuation.length; i++) {
                        localContribution = [];
                        localContribution.PartnerId =
                            filteredDirectInvestmentValuation[i].PartnerId;
                        localContribution.InvestmentId =
                            filteredDirectInvestmentValuation[i].InvestmentId;
                        localContribution.CommitmentFunded =
                            _.toNumber(filteredDirectInvestmentValuation[i].CommitmentFunded);
                        localContribution.CommitmentRemaining =
                            _.toNumber(filteredDirectInvestmentValuation[i].CommitmentRemaining);
                        localContribution.CommitmentTotal =
                            _.toNumber(
                                filteredDirectInvestmentValuation[i].CommitmentFunded
                            ) +
                            _.toNumber(
                                filteredDirectInvestmentValuation[i].CommitmentRemaining
                            );
                        localContribution.DistributionAmount =
                            _.toNumber(filteredDirectInvestmentValuation[i].PriorCashDistribution);
                        localContribution.ProjectedValue =
                            _.toNumber(filteredDirectInvestmentValuation[i].ProjectedValue);
                        localContribution.CurrentValue =
                            _.toNumber(filteredDirectInvestmentValuation[i].CurrentValue);
                        self.ContributionDistributionValuation.push(localContribution);
                    }
                    console.log(
                        "Contribution Distribution Valuation",
                        self.ContributionDistributionValuation
                    );
                } else {
                    if(self.ContributionDistributionValuation.length) {
                        localContribution = self.ContributionDistributionValuation;              
                    for (var i = 0; i < localContribution.length; i++) {
                        
                        let result = filteredDirectInvestmentValuation.filter( function(obj) {
                            return (obj.InvestmentId.toString() == localContribution[i].InvestmentId.toString());
                        })[0];

                        // console.log(result);

                        // let result1;
                        // filteredDirectInvestmentValuation.forEach(item => {
                        //     console.log(item, "\n",
                        //         localContribution[i].InvestmentId,"\n",
                        //         item.InvestmentId,"\n",
                        //         localContribution[i].InvestmentId == item.InvestmentId)
                        //     if(item.InvestmentId.toString() == localContribution[i].InvestmentId.toString()) {
                        //         result1 = item;
                        //     }
                        // })
                        // console.log("result",result);
                        // console.log("result1",result1);

                        if(result) {
                            // localContribution[i].PriorDistributionAmount =
                            //     _.toNumber(result.PriorCashDistribution);
                            // localContribution[i].PriorProjectedValue =
                            //     _.toNumber(result.ProjectedValue);
                            // localContribution[i].PriorCurrentValue =
                            //     _.toNumber(result.CurrentValue);  

                            localContribution[i].PriorDistributionAmount =
                                result.PriorCashDistribution;
                            localContribution[i].PriorProjectedValue =
                                result.ProjectedValue;
                            localContribution[i].PriorCurrentValue =
                                result.CurrentValue;  
                                

                        }

                    }
                    self.PriorContributionDistributionValuation = localContribution;
                    console.log(
                        "Prior Contribution Distribution Valuation",
                        self.PriorContributionDistributionValuation
                    );
                    }
                }
            } else {

            }
        },

        /*
        getEPPInvestment: function () {
            const self = this;
            //let filterQuery = { filter: "ShowOnFMVS eq 'Yes'" };
            let investmentAPIData = self.withFilter(self.BaseModelInvestment.list);
            
            let localEPPInvestment;
            if( self.PriorContributionDistributionValuation.length) {
                localEPPInvestment = self.PriorContributionDistributionValuation;
            } else {
                localEPPInvestment = self.ContributionDistributionValuation;
            }
            

            if (localEPPInvestment.length) {
                for (var i = 0; i < localEPPInvestment.length; i++) {
                    let result = investmentAPIData.filter(function (obj) {
                        return obj.Id == localEPPInvestment[i].InvestmentId;
                    })[0];

                    if (result) {
                        localEPPInvestment[i].InvestmentInvestmentID = result.InvestmentID;
                        localEPPInvestment[i].InvestmentTitle = result.Title;
                        localEPPInvestment[i].ShowOnFMVS = result.ShowOnFMVS;
                        localEPPInvestment[i].InvestmentInvestmentGroup =
                            result.InvestmentGroup ? result.InvestmentGroup : "";
                        localEPPInvestment[i].InvestmentStatementOrder =
                            result.StatementOrder;
                        if (result.HideNumberOnFMVS != null) {
                            localEPPInvestment[i].HideNumberOnFMVS = result.HideNumberOnFMVS;
                        }
                        else {
                            localEPPInvestment[i].HideNumberOnFMVS = "";
                        }
                    }
                }
            }

            let dataEPPInvestment = localEPPInvestment;

            //Add Direct Investment 
            dataEPPInvestment.forEach(item => {
                item.InvestmentInvestmentGroup = "Direct Investments";
            })
            //self.EPPInvestment = _.orderBy(dataEPPInvestment, ["InvestmentInvestmentGroup", "InvestmentStatementOrder"], ["desc", "asc"]);
            self.EPPInvestment = dataEPPInvestment;

            console.log("EPP Investment", self.EPPInvestment);
        },

        formEPPGridData: function () {
            const self = this;

            self.getContributionDistributionValuation(self.criteriaData.TaxPeriod);
            self.getContributionDistributionValuation(self.priorTaxPeriod, true);
            self.getEPPInvestment();

            self.EPPProgramTypeGridData = [];
            self.displayEPP = true;
            if (self.EPPInvestment.length) {
                for (var i = 0; i < self.EPPInvestment.length; i++) {
                    let localEPPGridData = [];

                    localEPPGridData.InvestmentGroup =
                        self.EPPInvestment[i].InvestmentInvestmentGroup;
                    localEPPGridData.InvestmentID =
                        self.EPPInvestment[i].InvestmentInvestmentID;
                    localEPPGridData.Investment = self.EPPInvestment[i].InvestmentTitle;
                    localEPPGridData.InvestmentOrder =
                        self.EPPInvestment[i].InvestmentStatementOrder;
                    localEPPGridData.HideNumberOnFMVS =
                        self.EPPInvestment[i].HideNumberOnFMVS;

                    localEPPGridData.CommitmentFunded =
                        _.toNumber(self.EPPInvestment[i].CommitmentFunded);
                    localEPPGridData.CommitmentRemaining =
                        _.toNumber(self.EPPInvestment[i].CommitmentRemaining);
                    localEPPGridData.CommitmentTotal =
                        _.toNumber(self.EPPInvestment[i].CommitmentTotal);

                    localEPPGridData.PreviousUnitDistribution =
                        _.toNumber(self.EPPInvestment[i].DistributionAmount);

                    localEPPGridData.ProjectedUnrealizedValue =
                        _.toNumber(self.EPPInvestment[i].ProjectedValue);

                    // PotentialPreTaxValue = DistributionAmount + ProjectedValue
                    localEPPGridData.PotentialPreTaxValue =
                        _.toNumber(self.EPPInvestment[i].DistributionAmount) +
                        _.toNumber(self.EPPInvestment[i].ProjectedValue);
                    localEPPGridData.TotalPotentialPreTaxValue =
                        _.toNumber(localEPPGridData.PotentialPreTaxValue);

                    // PriorPotentialPreTaxValue = PriorDistributionAmount + PriorProjectedValue
                    localEPPGridData.PriorPotentialPreTaxValue =
                        _.toNumber(self.EPPInvestment[i].PriorDistributionAmount) +
                        _.toNumber(self.EPPInvestment[i].PriorProjectedValue);

                    // PotentialPreTaxChange = (PotentialPreTaxValue  - PriorPotentialPreTaxValue)  / PriorPotentialPreTaxValue
                    // if (_.toNumber(localEPPGridData.PriorPotentialPreTaxValue) > 0) {
                    //     localEPPGridData.TotalPotentialPreTaxValuePercentChange =
                    //         (_.toNumber(localEPPGridData.PotentialPreTaxValue) -
                    //             _.toNumber(localEPPGridData.PriorPotentialPreTaxValue)) /
                    //         _.toNumber(localEPPGridData.PriorPotentialPreTaxValue);
                    // } else {
                    //     localEPPGridData.TotalPotentialPreTaxValuePercentChange = 0;
                    // }


                    if (_.toNumber(localEPPGridData.PriorPotentialPreTaxValue) == 0) {
                        if(self.EPPInvestment[i].PriorProjectedValue == 0 && _.toNumber(self.EPPInvestment[i].PriorDistributionAmount) != 0) {
                            localEPPGridData.TotalPotentialPreTaxValuePercentChange = 0;
                        } else {
                            localEPPGridData.TotalPotentialPreTaxValuePercentChange = "N/A";
                        }                       
                        
                    } else {
                        localEPPGridData.TotalPotentialPreTaxValuePercentChange =
                        (_.toNumber(localEPPGridData.PotentialPreTaxValue) -
                            _.toNumber(localEPPGridData.PriorPotentialPreTaxValue)) /
                        _.toNumber(localEPPGridData.PriorPotentialPreTaxValue);
                        
                    }

                    localEPPGridData.CurrentValue = _.toNumber(self.EPPInvestment[i].CurrentValue);
                    // CurrentPreTaxValue = DistributionAmount  + CurrentValue
                    localEPPGridData.CurrentPreTaxValue =
                        _.toNumber(self.EPPInvestment[i].DistributionAmount) +
                        _.toNumber(self.EPPInvestment[i].CurrentValue);
                    localEPPGridData.TotalCurrentPreTaxValue =
                        _.toNumber(localEPPGridData.CurrentPreTaxValue);

                    // PriorCurrentPreTaxValue = PriorDistributionAmount + PriorCurrentValue
                    localEPPGridData.PriorCurrentPreTaxValue =
                        _.toNumber(self.EPPInvestment[i].PriorDistributionAmount) +
                        _.toNumber(self.EPPInvestment[i].PriorCurrentValue);

                    //CurrentPreTaxChange = (CurrentPreTaxValue  - PriorCurrentPreTaxValue  ) / PriorCurrentPreTaxValue
                    // if (_.toNumber(localEPPGridData.PriorCurrentPreTaxValue) > 0) {
                    //     localEPPGridData.TotalCurrentPreTaxValuePercentChange =
                    //         (_.toNumber(localEPPGridData.CurrentPreTaxValue) -
                    //             _.toNumber(localEPPGridData.PriorCurrentPreTaxValue)) /
                    //         _.toNumber(localEPPGridData.PriorCurrentPreTaxValue);
                    // } else {
                    //     localEPPGridData.TotalCurrentPreTaxValuePercentChange = 0;
                    // }

                    if(_.toNumber(localEPPGridData.PriorCurrentPreTaxValue) == 0) {
                        if(self.EPPInvestment[i].PriorCurrentValue == 0 && _.toNumber(self.EPPInvestment[i].PriorDistributionAmount) != 0) {
                            localEPPGridData.TotalCurrentPreTaxValuePercentChange = 0;
                        } else {
                            localEPPGridData.TotalCurrentPreTaxValuePercentChange = "N/A";
                        }                       
                        //console.log('check!',localEPPGridData.PriorCurrentPreTaxValue,_.toNumber(localEPPGridData.PriorCurrentPreTaxValue));
                        
                    } else {
                       // console.log('non zero check!',localEPPGridData.PriorCurrentPreTaxValue,_.toNumber(localEPPGridData.PriorCurrentPreTaxValue));
                        localEPPGridData.TotalCurrentPreTaxValuePercentChange =
                            (_.toNumber(localEPPGridData.CurrentPreTaxValue) -
                                _.toNumber(localEPPGridData.PriorCurrentPreTaxValue)) /
                            _.toNumber(localEPPGridData.PriorCurrentPreTaxValue);
                    }

                    // Hotfix : Zero Datas Doesn't have to be displayed
                    // if (localEPPGridData.CommitmentFunded > 0 ||
                    //     localEPPGridData.CommitmentRemaining > 0 ||
                    //     localEPPGridData.CommitmentTotal > 0 ||
                    //     localEPPGridData.PreviousUnitDistribution > 0 ||
                    //     localEPPGridData.ProjectedUnrealizedValue > 0 ||
                    //     localEPPGridData.TotalPotentialPreTaxValue > 0 ||
                    //     localEPPGridData.TotalPotentialPreTaxValuePercentChange > 0 ||
                    //     localEPPGridData.CurrentValue > 0 ||
                    //     localEPPGridData.TotalCurrentPreTaxValue > 0 ||
                    //     localEPPGridData.TotalCurrentPreTaxValuePercentChange > 0) {

                        self.EPPProgramTypeGridData.push(localEPPGridData);
                    // }
                    
                }
            }

            //hot fix for TSEC, to show N/A instead of "-" making PVs null
            self.EPPProgramTypeGridData.forEach(item => {
                if(item.InvestmentID == 500061)
                {
                    item.ProjectedUnrealizedValue = null;
                    item.TotalPotentialPreTaxValuePercentChange = null;
                    item.TotalPotentialPreTaxValue = null;
                }
            })

            console.log("self.EPPProgramTypeGridData",self.EPPProgramTypeGridData);
            self.EPPProgramTypeGridData = _.sortBy(self.EPPProgramTypeGridData, ['InvestmentOrder']);
            // Make all the columns 0 if Hide Number is true. Then only the total row will have correct value for all columns.
            if (self.EPPProgramTypeGridData.length > 0) {
                self.EPPProgramTypeGridData = this.useInvestmentHideNumberOnFMVS(self.EPPProgramTypeGridData, 0, "EPP");
            }

            let CommitmentFundedTotal = _.sumBy(self.EPPProgramTypeGridData, "CommitmentFunded");
            let CommitmentRemainingTotal = _.sumBy(self.EPPProgramTypeGridData, "CommitmentRemaining");
            let CommitmentValueTotal = _.sumBy(self.EPPProgramTypeGridData, "CommitmentTotal");
            let PreviousUnitDistributionTotal = _.sumBy(self.EPPProgramTypeGridData, "PreviousUnitDistribution");
            let ProjectedUnrealizedValueTotal = _.sumBy(self.EPPProgramTypeGridData, "ProjectedUnrealizedValue");
            let TotalPotentialPreTaxValueTotal = _.sumBy(self.EPPProgramTypeGridData, "TotalPotentialPreTaxValue");
            let CurrentValueTotal = _.sumBy(self.EPPProgramTypeGridData, "CurrentValue");
            let TotalCurrentPreTaxValueTotal = _.sumBy(self.EPPProgramTypeGridData, "TotalCurrentPreTaxValue");

            var total = {
                "IndexGroup": 1,
                "CommitmentFundedTotal": CommitmentFundedTotal,
                "CommitmentRemainingTotal": CommitmentRemainingTotal,
                "CommitmentValueTotal": CommitmentValueTotal,
                "PreviousUnitDistributionTotal": PreviousUnitDistributionTotal,
                "ProjectedUnrealizedValueTotal": ProjectedUnrealizedValueTotal,
                "TotalPotentialPreTaxValueTotal": TotalPotentialPreTaxValueTotal,
                "CurrentValueTotal": CurrentValueTotal,
                "TotalCurrentPreTaxValueTotal": TotalCurrentPreTaxValueTotal
            };

            // To display "-" in Report.
            // if (self.EPPProgramTypeGridData.length > 0) {
            //     self.EPPProgramTypeGridData = this.useInvestmentHideNumberOnFMVS(self.EPPProgramTypeGridData, "&#8209;", "EPP");
            // }
            //console.log("flag!");
            self.EPPProgramTypeGridPdfData = [];
            let obj = _.groupBy(self.EPPProgramTypeGridData, "InvestmentGroup");
            //console.log("epp obj",obj);
            Object.keys(obj).forEach((key, val) => {
                self.EPPProgramTypeGridPdfData.push({
                    "InvestmentGroup": obj[key][0], "IndexGroup": 0,
                });
                self.EPPProgramTypeGridPdfData.push.apply(self.EPPProgramTypeGridPdfData, obj[key]);
            });
            if (self.EPPProgramTypeGridPdfData.length != 0)
                self.EPPProgramTypeGridPdfData.push(total);
        },
*/

        getAssociatedPrograms(partnerId) {
            let programArray = new Set();
            let UnitRunningTotalData = this.withFilter(this.BaseModelUnitRunningTotal.list, "")
            //Nested Grouping by partnerid,unitclass,unittype
            const getConfig1 = item => item.PartnerId;

            let groupByResult = deepGroupBy(UnitRunningTotalData, getConfig1);
            let groupedPartnerData = groupByResult[partnerId]
            if (groupedPartnerData) {
                groupedPartnerData.forEach(element => {
                    programArray.add(element.ProgramId)
                });
            }
            return [...programArray];
        },
        getAssociatedInvestment(programArray) {
            let InvestmentArray = new Set();
            let ProgramData = this.withFilter(this.BaseModelProgram.list, "");
            if (programArray && programArray.length > 0 && ProgramData) {
                programArray.forEach(programId => {
                    let index = ProgramData.findIndex(m => m.Id == programId)
                    if (index >= 0) {
                        InvestmentArray.add(ProgramData[index].InvestmentId)
                    }
                });
            }
            return [...InvestmentArray];
        },
        getProgramInvestmentText(MemoData, AssociatedPrograms, AsscoiatedInvestments) {
            let textArray = [];
            let memoByProgramInvestment = _.filter(MemoData, function (item) {
                return item.MemoType == "Program" || item.MemoType == "Investment"
            });
            if (memoByProgramInvestment && memoByProgramInvestment.length > 0) {
                if (AssociatedPrograms.length > 0) {
                    AssociatedPrograms.forEach(programId => {
                        let filteredProgramArray = memoByProgramInvestment.filter(m => m.ProgramId == programId)
                        Array.prototype.push.apply(textArray, filteredProgramArray);
                    });
                }
                if (AsscoiatedInvestments.length > 0) {
                    AsscoiatedInvestments.forEach(investmentId => {
                        let filteredInvestmentArray = memoByProgramInvestment.filter(m => m.InvestmentId == investmentId)
                        Array.prototype.push.apply(textArray, filteredInvestmentArray);
                    });
                }
            }
            return textArray;
        },
        getFootNoteText(footNoteId) {
            const self = this;
            let Footnotelist = self.withFilter(self.BaseModelFootnote.list);
            let result = _.filter(Footnotelist, function (Footnote) {
                return Footnote.Id == footNoteId;
            });
            if (result && result[0]) {
                return result[0].Footnote;
            } else {
                return ""
            }
        },

        getFilteredInvestment(inputArray) {
            //return inputArray;
            let ProgramData = this.withFilter(this.BaseModelProgram.list, "");
            if (inputArray && inputArray.length > 0 && ProgramData) {
                return inputArray.filter(program => {
                    let index = ProgramData.findIndex(m => m.Id == program.ProgramId);
                    if (index >= 0) {
                        let filterQuery = { filter: "Id eq " + ProgramData[index].InvestmentId + " and ShowOnFMVS eq 'Yes'" };

                        if (this.withFilter(this.BaseModelInvestment.list, filterQuery).length > 0) {
                            return true;
                        }
                    }
                    return false;
                });
            }
        },

        useInvestmentHideNumberOnFMVS(inputArray, strValue, EumorEPP) {
            if (inputArray && inputArray.length > 0) {
                inputArray.forEach(element => {
                    if (element.HideNumberOnFMVS.length) {
                        if (EumorEPP === "EUM") {
                            if (element.HideNumberOnFMVS.indexOf("PreviousUnitDistribution") >= 0)
                                element.PreviousUnitDistribution = strValue;
                            if (element.HideNumberOnFMVS.indexOf("ProjectedUnrealizedValue") >= 0)
                                element.ProjectedUnrealizedValue = strValue;
                            if (element.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValues") >= 0)
                                element.TotalPotentialPreTaxValue = strValue;
                            if (element.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValuePercentChange") >= 0)
                                element.TotalPotentialPreTaxValuePercentChange = strValue;
                            if (element.HideNumberOnFMVS.indexOf("CurrentValue") >= 0)
                                element.CurrentValue = strValue;
                            if (element.HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValues") >= 0)
                                element.TotalCurrentPreTaxValue = strValue;
                            if (element.HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValuePercentChange") >= 0)
                                element.TotalCurrentPreTaxValuePercentChange = strValue;
                        }
                        if (EumorEPP === "EPP") {
                            if (element.HideNumberOnFMVS.indexOf("PreviousUnitDistribution") >= 0)
                                element.PreviousUnitDistribution = strValue;
                            if (element.HideNumberOnFMVS.indexOf("ProjectedUnrealizedValue") >= 0)
                                element.ProjectedUnrealizedValue = strValue;
                            if (element.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValues") >= 0)
                                element.TotalPotentialPreTaxValue = strValue;
                            if (element.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValuePercentChange") >= 0)
                                element.TotalPotentialPreTaxValuePercentChange = strValue;
                            if (element.HideNumberOnFMVS.indexOf("CurrentValue") >= 0)
                                element.CurrentValue = strValue;
                            if (element.HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValues") >= 0)
                                element.TotalCurrentPreTaxValue = strValue;
                            if (element.HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValuePercentChange") >= 0)
                                element.TotalCurrentPreTaxValuePercentChange = strValue;
                        }
                    }
                });
            }
            return inputArray;
        },
        // Convert -0.00 to 0.00
        getZeros(number){
            let num = _.toNumber(number).toFixed(2);
            if(num == -0.00) {
                num = 0.00
            } 
            return num;
        },

        //Hotfix : Check partner is in transfer
        getTransferStatus(partnerId) {
            const self = this;
            for(let i = 0; i < self.ExceptionTransferPartnerId.length; i++) {
                if(self.criteriaData.Partner.Id == self.ExceptionTransferPartnerId[i]) {
                    return true;
                }
            }
            return false;
        }
    }
}